import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { docs } from '../../components/LegalLayout';
import { FileText, ShieldCheck, ChevronRight, Download } from 'lucide-react';

const LegalIndex = () => (
  <div className="min-h-screen bg-[#fdfaf6] flex flex-col" data-testid="legal-index">
    <Navbar />
    <div className="flex-1 max-w-4xl mx-auto w-full px-5 lg:px-8 py-14">
      <div className="text-center">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-orange-400 to-rose-500 flex items-center justify-center">
          <ShieldCheck className="w-7 h-7 text-white" />
        </div>
        <h1 className="mt-5 text-3xl lg:text-4xl font-extrabold text-slate-900 tracking-tight">Legal &amp; Compliance</h1>
        <p className="mt-2 text-slate-600 max-w-2xl mx-auto">
          Transparent, plain-English policies. MyBusinessAdPro is a product of <strong>Krinal Ahir Ltd</strong>
          {' '}(Co. No. 11940942), registered in England &amp; Wales, and we take your data, rights, and UK advertising
          standards seriously.
        </p>

        <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-50 border border-orange-200 text-xs font-semibold text-orange-700" data-testid="uk-territory-chip" aria-label="Service available UK-wide">
          <span aria-hidden="true">🇬🇧</span>
          Serving businesses across England, Wales, Scotland &amp; Northern Ireland
        </div>
      </div>

      <div className="mt-8">
        <a
          href="/legal-pack/mbap-legal-pack.zip"
          download="MyBusinessAdPro_Legal_Pack.zip"
          data-testid="download-legal-pack-btn"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-orange-500 to-rose-500 text-white font-semibold hover:from-orange-400 hover:to-rose-400 transition-all shadow-md"
        >
          <Download className="w-5 h-5" /> Download full pack (ZIP, for solicitor hand-off)
        </a>
      </div>

      <div className="mt-10 space-y-3">
        {docs.map(d => {
          const Icon = d.icon;
          return (
            <Link
              key={d.to}
              to={d.to}
              data-testid={`legal-card-${d.to.split('/').pop()}`}
              className="group flex items-center gap-4 p-5 bg-white rounded-2xl border border-slate-200 hover:border-orange-300 hover:shadow-md transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-orange-100 to-rose-100 flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5 text-orange-600" />
              </div>
              <div className="flex-1">
                <div className="font-semibold text-slate-900">{d.label}</div>
                <div className="text-sm text-slate-500">Read the full document</div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-orange-500 group-hover:translate-x-1 transition-all" />
            </Link>
          );
        })}
      </div>

      <div className="mt-10 bg-white rounded-2xl border border-slate-200 p-6">
        <div className="flex items-start gap-3">
          <FileText className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-slate-700">
            <div className="font-semibold text-slate-900">Data protection contact</div>
            Data controller: Krinal Ahir Ltd (Co. No. 11940942), trading as MyBusinessAdPro. For any data-subject requests under UK GDPR, email
            <a href="mailto:contact@mybusinessadpro.co.uk" className="text-orange-600 font-medium ml-1">contact@mybusinessadpro.co.uk</a>.
            You also have the right to complain to the UK Information Commissioner's Office (ICO) at
            <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-orange-600 font-medium ml-1">ico.org.uk</a>.
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default LegalIndex;
